import { decode } from 'he'
import { Slugger } from 'marked'

import Heading from '../Heading/Heading'

import css from './ImageHeading.module.css'

export type ImageHeadingProps = {
    level: string
    title: string
    imageUrl: string
    imageAlt?: string
}

export default function ImageHeading({
    level = 'h2',
    title = '',
    imageUrl,
    imageAlt,
}: ImageHeadingProps) {
    const slug = new Slugger().slug(decode(title))
    return (
        <Heading level={level} className={css.imageHeading} slug={slug}>
            {imageUrl && <img src={imageUrl} alt={imageAlt} />}
            {title}
        </Heading>
    )
}
